import React from "react";
import {Input} from "reactstrap";
import WrapperIonCheckbox from "../../ionic/WrapperIonCheckbox";
import get from 'lodash/get'


const CheckboxField = (props) => {
    const myOnChange = (checked) => {
        props.onChange(checked);
    };

    if (props.formData !== true && props.formData !== false) {
        props.onChange(false);
    }

    const description = props.schema.description || props.uiSchema['ui:description'];
    return <>
        <div className="checkbox-field">
            <div>
                <div className="checkbox-field-label">
                    {get(props.schema, 'title')}
                    {(props.schema.title && props.required) ? ' *' : ''}
                </div>
                <div className="checkbox-field-description">
                    {description}
                </div>
            </div>
            <div className="d-flex">
                <WrapperIonCheckbox
                    id={get(props.idSchema, '$id')}
                    checked={props.formData}
                    readOnly={get(props.uiSchema, 'ui:readonly')}
                    callback={myOnChange}
                />
            </div>
        </div>
        <br />
        {/* <Input
            type="checkbox"
            id={get(props.idSchema, '$id')}
            checked={props.formData}
            readOnly={get(props.uiSchema, 'ui:readonly')}
            onChange={myOnChange}
            label={
                <>
                    {get(props.schema, 'title')}
                    {(props.schema.title && props.required) ? ' *' : ''}
                </>
            }
        />
        <small className="form-text text-muted mb-3 mt-2">
            {description}
        </small> */}
    </>;
};

export default CheckboxField;
